<div class="flex">
    <div class="icon-stack">
        <mat-icon class="base-icon">desktop_windows</mat-icon>
        <mat-icon class="overlay-icon-apps">apps</mat-icon>
        <mat-icon *ngIf="displaySignInButton" class="overlay-icon-clear">highlight_off</mat-icon>
    </div>
    <div class="arcGisUserMessageDisplay">
      {{userMessage}}
    </div>
    <div *ngIf="displayUserName" class="user-info">
      <mat-icon class="person-icon">person</mat-icon>
      <span class="user-name">{{displayUserName}}</span>
    </div>
    <div class="arcGisUserButton">
        <button id="signIn" mat-button type="submit" [ngClass]="{ 'logged-in' : !displaySignInButton, 'logged-out' : displaySignInButton }" 
                class="btn btn-small btn-fill" (click)="signInOut()">
            <div *ngIf="displaySignInButton">
                <mat-icon>login</mat-icon>
                {{'HOME.ARCGIS.SIGN_IN' | translate}}
            </div>
            <div *ngIf="!displaySignInButton">
                <mat-icon>logout</mat-icon>
                {{'HOME.ARCGIS.SIGN_OUT' | translate}}
            </div>
        </button>
    </div>    
</div>
